import React, { useEffect, useState } from 'react';
import styles from './AdminTableList.module.scss';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Button, CircularProgress, IconButton, Pagination, TableFooter, Typography } from '@mui/material';
import { Add, Delete, Edit, Lock, LockOpen, OpenInBrowser, OpenInNew } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import axios from 'axios';
import { apiUrl } from '../../../utils/apiUrl';
import Loading from '../Loading/Loading';
import InfoAlert from '../InfoAlert/InfoAlert';
import { amber, blue, cyan, deepPurple, indigo, purple, teal } from '@mui/material/colors';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import DeleteBtn from '../DeleteBtn/DeleteBtn';
const AdminTableList = ({ perPage = 10, onAdd, isAction, isDeleteOnly = false, columns, fetch, sliceName, actionName, title, pathEdit, getTableListRequest = () => {}, textEmpty, propName, type, pathList, deleteProps = {}, blockProps = {}, unblockProps = {}, noLock, onEdit, createData, updateData }) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetch({ page }));
  }, [page]);
  useEffect(() => {
    if (createData) {
      dispatch(fetch({ page }));
    }
  }, [createData]);
  useEffect(() => {
    if (updateData) {
      dispatch(fetch({ page }));
    }
  }, [updateData]);

  const [deletePageRequest, setDeletePageRequest] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  function deleteReqest(deleteId) {
    setDeletePageRequest({ loading: true });
    axios.post(apiUrl('page/delete'), { deleteId }).then(() => {
      setShowAlert(true);
      setDeletePageRequest({ loading: false, data: true });
      setTimeout(() => {
        setShowAlert(false);
        // getTableListRequest();
      }, 500);
    });
  }

  const selector = useSelector((state) => state[sliceName]);
  const selectorData = selector[actionName];
  const data = selectorData?.data;
  const loading = selectorData?.loading;
  console.log(data);
  const [selectedRow, setSelectedRow] = useState();
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {' '}
        <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '600', mb: 4 }}>
          {title}
        </Typography>
        {onAdd && (
          <Button onClick={onAdd} variant="contained" sx={{ mb: 4 }} endIcon={<Add />}>
            Добавить
          </Button>
        )}
      </Box>

      {loading && !data ? (
        <CircularProgress sx={{ display: 'block', margin: '0 auto', mt: 4 }} />
      ) : data?.list?.length >= 1 ? (
        <>
          <TableContainer
            component={Paper}
            sx={{
              '&.MuiPaper-root': {
                overflowY: 'hidden',
              },
            }}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ '& th': { padding: '4px' } }}>
                  {columns?.map((col) => (
                    <TableCell align="center" sx={{ fontSize: '12px', lineHeight: '14px', fontWeight: '600', width: col?.width }}>
                      {col?.label}
                    </TableCell>
                  ))}

                  {/* <TableCell align="center">Путь</TableCell> */}
                  {/* <TableCell width="90px" align="center">
                    Открыть
                  </TableCell> */}
                  {/* <TableCell width="90px" align="center" sx={{ fontSize: '12px', lineHeight: '14px' }}>
                    Редактировать
                  </TableCell> */}
                  {!noLock && !isAction && <TableCell width="20px"></TableCell>}

                  {isAction && (
                    <>
                      {!isDeleteOnly && <TableCell width="20px"></TableCell>}
                      <TableCell width="20px"></TableCell>
                    </>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.list?.map((item) => (
                  <TableRow
                    key={item.id}
                    sx={{ ...(item.id === selectedRow && { background: 'rgba(144,202,249,0.2)' }), cursor: 'pointer', '& td': { padding: '4px 8px' }, '&:last-child td, &:last-child th': { border: 0 } }}
                    onMouseEnter={() => {
                      setSelectedRow(item.id);
                    }}
                    onMouseLeave={() => {
                      setSelectedRow();
                    }}
                    onClick={() => {
                      if (onEdit) {
                        onEdit(item);
                      } else if (pathEdit) {
                        navigate(`${pathEdit}/${item?.id}`);
                      }
                    }}>
                    {columns?.map((col) => (
                      <TableCell align="center">
                        <Box sx={{ fontSize: '12px', display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '0 auto', whiteSpace: 'nowrap' }}>{col?.value ? item?.[col?.value] : col?.onTransform?.(item)}</Box>
                      </TableCell>
                    ))}
                    {isAction ? (
                      <>
                        {!isDeleteOnly && (
                          <TableCell>
                            {' '}
                            {item?.status == 'ACTIVE' ? (
                              <DeleteBtn
                                isIcon
                                {...blockProps}
                                type={type}
                                id={item.id}
                                onDelete={() => {
                                  dispatch(fetch({ page }));
                                }}
                              />
                            ) : (
                              <DeleteBtn
                                isIcon
                                {...unblockProps}
                                type={type}
                                id={item.id}
                                onDelete={() => {
                                  dispatch(fetch({ page }));
                                }}
                              />
                            )}
                          </TableCell>
                        )}
                      </>
                    ) : noLock ? (
                      <></>
                    ) : (
                      <TableCell>{item?.status == 'ACTIVE' ? <LockOpen color="success" /> : <Lock color="error" />}</TableCell>
                    )}

                    {isAction && (
                      <>
                        <TableCell>
                          <DeleteBtn
                            {...deleteProps}
                            isIcon
                            type={type}
                            id={item.id}
                            onDelete={() => {
                              dispatch(fetch({ page }));
                            }}
                          />
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            sx={{ mt: 3 }}
            count={Math.ceil(data?.count / perPage)}
            page={page}
            onChange={(val, e) => {
              setPage(e);
              // console.log(e);
            }}
          />
        </>
      ) : (
        <Box sx={{ mt: 3, textAlign: 'center', fontSize: '20px', fontWeight: '600', color: 'rgba(0,0,0,0.5)' }}>{textEmpty}</Box>
      )}
      {deletePageRequest?.loading && <Loading />}

      <InfoAlert show={showAlert} text={'Запись удалена'} />
    </>
  );
};

export default AdminTableList;
